<template>
    <Progressbar v-if="loading && !cooperationSale.description" />
    <NetworkError v-else-if="errors" @tryAgain="getCooperationSale()" />
    <div class="hero flex-1" v-else>
        <div class="hero-content flex-col lg:flex-row">
            <div class="card bg-white m-auto max-w-2xl">
                <div class="card-body p-4 sm:p-5 md:p-8">
                    <img :src="logo" class="w-32 md:w-36 mx-auto" />
                    <div class="text-center mt-3">
                        <h1 class="text-lg font-bold">{{ __('Cooperation in sales') }}</h1>
                        <p class="py-6" v-html="cooperationSale.description"></p>
                        <div class="flex flex-row items-center mb-3" v-if="cooperationSale.active">
                    <input class="input input-sm md:input-md input-bordered w-full text-sm" dir="ltr" readonly :value="referralLink" />
                    <button class="btn btn-outline btn-sm md:btn-md md:!px-6 btn-primary mr-3" @click="copyLink($event,'The desired link was copied successfully')">{{ __('Copy') }}</button>
                </div>
                        <a :href="saleLink" class="btn btn-primary" v-if="cooperationSale.registered">{{ __('Login to the sales cooperation panel') }}</a>
                        <Form @submit="onSubmit" v-slot="{ errors }" class="flex mt-3" v-else>
                            <Field type="text" dir="ltr" :placeholder="__('Website address or social network')" name="page" :disabled="loading"
                                v-model="page" rules="required" :class="{ 'input-error': errors.page }"
                                class="input text-center text-blue-custom-2 bg-blue-custom-1 placeholder-blue-custom-2 flex-1" />
                            <button type="submit" class="btn btn-primary mr-3" :class="{'loading': loading}">{{ __('Registration and login') }}</button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { onMounted, computed, ref } from "vue";
import useHome from "../../../composables/shop/home";
import { Field, Form } from "vee-validate";
import { useToast } from "vue-toastification";
import { copyText } from 'vue3-clipboard'
import Auth from "../../../composables/shop/auth";
const page = ref('');
const { cooperationSale, getCooperationSale, errors, loading,registerCooperationSale } = useHome();
const logo = window.nikran.logo;
const saleLink =  window.APP_URL + '/sale';
const onSubmit = () => registerCooperationSale(page.value);
const toast = useToast();
const referralLink = computed(() => APP_URL + '/app/register?ref=' + Auth.user.value.referral_code)
const copyLink = (e,message) => {
    copyText(e.target.previousSibling.value, undefined, (error, event) => {
        if (error) toast.error(window.i18n['Error in copy operation!']);
        else toast.success(window.i18n[message]);
    })
};
onMounted(() => getCooperationSale());
</script>